/**
 * Privacy Policy marketing page (`/privacy`) — GitHub issue "Create React
 * components for static marketing pages using vite-react-ssg".
 * Statically generated; no client-side data fetching or auth dependency.
 */
import { useTranslation } from 'react-i18next';

import MarketingLayout from '@/components/marketing/MarketingLayout';
import SeoHead from '@/components/marketing/SeoHead';

export default function PrivacyPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <MarketingLayout>
      <SeoHead
        title={t('marketing.privacy.title')}
        description={t('marketing.privacy.description')}
        path="/privacy"
      />

      <section className="container mx-auto max-w-3xl px-4 py-16">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          {t('marketing.privacy.heading')}
        </h1>
        <p className="mt-4 text-xl text-muted-foreground">{t('marketing.privacy.subheading')}</p>
        <p className="mt-8 leading-relaxed text-muted-foreground">{t('marketing.privacy.body')}</p>
      </section>
    </MarketingLayout>
  );
}
